import { Injectable } from '@angular/core';

// export type FaceKey = 'home' | 'about' | 'resume' | 'portfolio' | 'blog' | 'contact';
export type FaceKey = 'home';

@Injectable({ providedIn: 'root' })
export class FaceReadyService {
  private states = new Map<FaceKey, boolean>();
  private resolvers: Array<() => void> = [];

  markReady(face: FaceKey): void {

    this.states.set(face, true);
    this.tick();

  }

  markNotReady(face: FaceKey): void {
    this.states.set(face, false);
  }

  isReady(face: FaceKey): boolean {
    return this.states.get(face) === true;
  }

  async waitAll(faces: FaceKey[]): Promise<void> {
    if (faces.every(f => this.isReady(f))) return;

    await new Promise<void>(resolve => {
      this.resolvers.push(resolve);
      this.tick();
    });
  }

  private tick(): void {
    // wenn alle bekannten required faces ready sind -> resolve alle
    // (die waitAll-Liste wird unten geprüft; hier lösen wir einfach “potenziell” aus)
    const resolvers = this.resolvers.slice();
    this.resolvers = [];
    resolvers.forEach(r => r());
  }
}
